import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { ICommunity, ICommunityStatistics, ILatestTransaction, IListCommunityTransactionRequest, IRegistrationStatistics } from "./types"
import { IWalletBalance } from "@/shared/types"
import { IBonusTransactionsAggregates, IGetBonusTransactions } from "@/shared/api/bonuses"

export const getCommunity = (): Promise<AxiosResponse<ICommunity>> => {
    return apiInstance.handler.get<ICommunity>('/communities/info')
}

export const getCommunityStatistics = (): Promise<AxiosResponse<ICommunityStatistics>> => {
    return apiInstance.handler.get<ICommunityStatistics>(`/communities/summary`)
}

export const getMainWalletBalance = (): Promise<AxiosResponse<IWalletBalance>> => {
    return apiInstance.handler.get<IWalletBalance>(`/communities/balance`)
}

export const getMasterWalletBalance = (): Promise<AxiosResponse<number>> => {
    return apiInstance.handler.get<number>(`/communities/master-wallet`)
}

export const getAccrualReports = (startDate: Date, endDate: Date): Promise<AxiosResponse> => {
    return apiInstance.handler.get(`/communities/accrual-report-xlsx`, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        params: {
            start_date: startDate.toISOString(),
            end_date: endDate.toISOString()
        }
    })
}

export const getCommunityTransactionAggregates = (startDate: Date, endDate: Date): Promise<AxiosResponse<IBonusTransactionsAggregates>> => {
    return apiInstance.handler.get<IBonusTransactionsAggregates>(`/communities/transactions-statistics`, {
        params: {
            interval: 'day',
            date_from: startDate.toISOString(),
            date_to: endDate.toISOString()
        }
    })
}

export const getRegistrationStatistics = (startDate: Date, endDate: Date): Promise<AxiosResponse<IRegistrationStatistics>> => {
    return apiInstance.handler.get<IRegistrationStatistics>(`/communities/registration-statistics`, {
        params: {
            start_date: startDate.toISOString(),
            end_date: endDate.toISOString()
        }
    })
}

export const getLatestTransactions = (): Promise<AxiosResponse<ILatestTransaction[]>> => {
    return apiInstance.handler.get<ILatestTransaction[]>(`/communities/latest-transactions`)
}

export const getCommunityTransactions = (data: IListCommunityTransactionRequest): Promise<AxiosResponse<IGetBonusTransactions>> => {
    return apiInstance.handler.get<IGetBonusTransactions>(`/communities/transactions`, {
        params: {
            page: data.page,
            per_page: data.limit,
            date_from: data.startDate,
            date_to: data.endDate,
            with_total_count: 1,
            bonus_id: data.bonusId,
        }
    })
}

export const setDefaultGroup = (groupId: string): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.put<void>(`/communities/default-group`, { group_id: groupId })
}
